<template>
  <div class="lostpassword-page">
    <TopBarUnLogin />
    <LostPasswordPage />
    <FooterBarWhite />
  </div>
</template>

<script>
import TopBarUnLogin from '@/components/TopBarUnLogin.vue'
import LostPasswordPage from '@/components/LostPasswordPage.vue'
import FooterBarWhite from '@/components/FooterBar/FooterBarWhite.vue'

export default {
  name: 'LostPassword',
  components: {
    TopBarUnLogin,
    LostPasswordPage,
    FooterBarWhite
  }
}
</script>